export default __webpack_public_path__ + "static/media/medium.5a7ac75e.svg";